import { SET_FIELD_VALUE, CLEAR_STORE } from "../../constants/actionTypes";

export const setFieldValue = (name, field, value) => ({
  type: SET_FIELD_VALUE,
  name,
  field,
  value,
});

export const clearStore = (name) => ({
  type: CLEAR_STORE,
  name,
});
